var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v(_vm._s(_vm.FuncionesGenerales.formatoFecha(_vm.store.state.horaActual, 2)))])}
var staticRenderFns = []

export { render, staticRenderFns }